import { connect } from 'react-redux';

import MapStylePresetsModal from './map_style_presets_modal.jsx';

import {
  closeModal
} from 'zoomforth_codesbane_editor/action_creators/editor_modals.js';

import {
  setCurrentTheme
} from 'zoomforth_codesbane_editor/action_creators/theme.js';

const mapStateToProps = (state, { newThemeData })=> {
  return { newThemeData };
};

const mapDispatchToProps = (dispatch, { newThemeData })=> {
  return {
    onRequestClose: ()=> { 
      dispatch(closeModal()); 
    },
    onMapStylePresetsClick: (stylePresetMapping)=> {
      dispatch(setCurrentTheme(newThemeData, stylePresetMapping));
      dispatch(closeModal()); 
    },
    onApplyThemeWithoutMappingClick: ()=> {
      dispatch(setCurrentTheme(newThemeData));
      dispatch(closeModal()); 
    }
  };
};

const Modal = connect(
  mapStateToProps,
  mapDispatchToProps
)(MapStylePresetsModal);

Modal.editorModalName = 'MapStylePresetsModal';

export default Modal;
